module.exports = __webpack_public_path__ + "img/4-8-1.b44f7e1e.png";